import {createPaginationContainer, graphql} from 'react-relay';
import {injectIntl} from 'react-intl';
import {withRouter} from 'react-router-dom';

const PersonLoader = ({relay: {hasMore, isLoading, loadMore}, viewer, children, ...props}) => {
	const formatData = () => {
		return viewer.company.resourceBasedPersons.edges.map(person => {
			const {id, firstName, lastName, profilePictureId} = person.node;
			return {
				person: {
					id,
					firstName,
					lastName,
					profilePictureId,
				},
				resourceNumbers: {
					...person.node.resourceNumbers,
				},
			};
		});
	};
	const loadMoreFunc = hasMore() ? loadMore : undefined;
	return children({data: {rows: formatData()}, loadMore: loadMoreFunc, loading: isLoading(), ...props});
};

export const personLoaderQuery = graphql`
	query PersonLoaderQuery_Query($searchQuery: TaskSearchQueryType, $startYear: Int!, $startMonth: Int!, $startDay: Int!, $endYear: Int!, $endMonth: Int!, $endDay: Int!, $pageSize: Int!, $cursor: String) {
		viewer {
			actualPersonId
			component(name: "utilization_period_person_loader")
			...PersonLoader_viewer @arguments(searchQuery: $searchQuery, startYear: $startYear, startMonth: $startMonth, startDay: $startDay, endYear: $endYear, endMonth: $endMonth, endDay: $endDay, pageSize: $pageSize, cursor: $cursor)
		}
	}
`;

export default injectIntl(
	withRouter(
		createPaginationContainer(
			PersonLoader,
			{
				viewer: graphql`
					fragment PersonLoader_viewer on Viewer
					@argumentDefinitions(
						searchQuery: {type: "TaskSearchQueryType"}
						startYear: {type: "Int!"}
						startMonth: {type: "Int!"}
						startDay: {type: "Int!"}
						endYear: {type: "Int!"}
						endMonth: {type: "Int!"}
						endDay: {type: "Int!"}
						pageSize: {type: "Int!"}
						cursor: {type: "String"}
					) {
						company {
							resourceBasedPersons(first: $pageSize, after: $cursor, searchQuery: $searchQuery, startYear: $startYear, startMonth: $startMonth, startDay: $startDay, endYear: $endYear, endMonth: $endMonth, endDay: $endDay)
								@connection(key: "Company_resourceBasedPersons") {
								edges {
									node {
										id
										firstName
										lastName
										profilePictureId
										resourceNumbers(startYear: $startYear, startMonth: $startMonth, startDay: $startDay, endYear: $endYear, endMonth: $endMonth, endDay: $endDay) {
											# Actuals
											actualBillableProjectMinutes
											actualNonBillableProjectMinutes
											actualInternalMinutes
											actualTotalMinutes
											actualOverMinutes
											actualDoneTaskMinutes
											actualBillableUtilization
											actualNonBillableUtilization
											actualInternalUtilization
											actualResourceUtilization

											# Plan
											plannedBillableProjectMinutes
											plannedNonBillableProjectMinutes
											plannedInternalMinutes
											plannedTotalMinutes
											plannedOverMinutes
											plannedDoneTaskMinutes
											plannedBillableUtilization
											plannedNonBillableUtilization
											plannedInternalUtilization
											plannedResourceUtilization

											# Remaining
											remainingBillableProjectMinutes
											remainingNonBillableProjectMinutes
											remainingInternalMinutes
											remainingTotalMinutes
											remainingOverMinutes
											remainingBillableUtilization
											remainingNonBillableUtilization
											remainingInternalUtilization
											remainingResourceUtilization

											# Forecast
											forecastBillableProjectMinutes
											forecastNonBillableProjectMinutes
											forecastInternalMinutes
											forecastTotalMinutes
											forecastOverMinutes
											forecastBillableUtilization
											forecastNonBillableUtilization
											forecastInternalUtilization
											forecastResourceUtilization

											# Actuals vs. Plan
											billableActualVsPlan
											nonBillableActualVsPlan
											internalActualVsPlan
											totalActualVsPlan

											# Availability
											workingMinutes
											timeOffMinutes
											availableMinutes

											# Performance
											performance
										}
									}
								}
							}
						}
					}
				`,
			},
			{
				direction: 'forward',
				getConnectionFromProps({viewer}) {
					return viewer.company.resourceBasedPersons;
				},
				getFragmentVariables(prevVars) {
					return {
						...prevVars,
					};
				},
				getVariables(_, {cursor}, fragmentVariables) {
					return {
						...fragmentVariables,
						cursor,
					};
				},
				query: graphql`
					query PersonLoaderRefetchQuery($pageSize: Int, $cursor: String, $startYear: Int!, $startMonth: Int!, $startDay: Int!, $endYear: Int!, $endMonth: Int!, $endDay: Int!, $searchQuery: TaskSearchQueryType) {
						viewer {
							...PersonLoader_viewer
								@arguments(pageSize: $pageSize, cursor: $cursor, startYear: $startYear, startMonth: $startMonth, startDay: $startDay, endYear: $endYear, endMonth: $endMonth, endDay: $endDay, searchQuery: $searchQuery)
						}
					}
				`,
			}
		)
	)
);
